// extracted by mini-css-extract-plugin
export default {"menuItem":"KBecFVSxeVN0e6QzgF_A"};